import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import GiftcardDetailsWeb from "./layouts/GiftcardDetails.web";
import GiftcardDetailsMob from "./layouts/GiftcardDetails.mob";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import { Grid } from "antd";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { useEffect, useState } from "react";
import { useGetGiftcardDetailsQuery } from "src/store/apis/giftcards";
import { GiftcardDetailsHeader, GiftcardDetailsSkeleton } from "./components";
import NoData from "@Components/NoData/NoData";

const GiftcardDetailsComponent = withConditionalComponent(GiftcardDetailsWeb, GiftcardDetailsMob);

export default function GiftcardDetails() {
  const { code } = useParams();
  const { t, i18n } = useTranslation();

  const { data: items = [], isFetching, error } = useGetGiftcardDetailsQuery({ PageSize: 10000, Page: 1, code, lang: i18n.language });

  const imageUrl = items?.[0]?.imageUrl ?? undefined;
  const brandName = items?.[0]?.brand;
  const isLargeScreen = Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const [selectedItemIndex, setSelectedItemIndex] = useState(0);
  const rawData = items?.[selectedItemIndex];

  const isRange = rawData?.denominationType?.toLowerCase() === "range";
  const rangeMin = Number(rawData?.from ?? 0);
  const [rangeValue, setRangeValue] = useState(rangeMin);

  useEffect(() => {
    setRangeValue(rangeMin);
  }, [rawData, rangeMin]);

  const effectiveData =
    isRange && rawData
      ? {
          ...rawData,
          totalPrice: rangeValue,
          points: Math.round(rangeValue * (rawData.pointsFactor ?? 1)),
        }
      : rawData;

  const itemCode = rawData?.code;

  return (
    <div className="bg-background-default flex w-full flex-1 flex-col items-start gap-5 p-6 md:p-10">
      <GiftcardDetailsHeader brandName={brandName} isFetching={isFetching}/>
      {isFetching && (
        <div className="flex w-full flex-1 items-start justify-center md:p-5">
          <GiftcardDetailsSkeleton />
        </div>
      )}
      {!isFetching && error && (
        <div className="flex w-full flex-1 items-center justify-center">
          <NoData description={t("Giftcards.detailsUnavailable")} className="h-full w-full" />
        </div>
      )}
      {!isFetching && !error && (
        <div className="flex w-full flex-1 items-start justify-center md:p-5">
          <GiftcardDetailsComponent
            trigger={isLargeScreen}
            props={{
              data: effectiveData,
              imageUrl,
              itemCode,
              items,
              selectedItemIndex,
              setSelectedItemIndex,
              brandName,
              rangeValue,
              onRangeChange: setRangeValue,
            }}
          />
        </div>
      )}
    </div>
  );
}
